import React, { useState, useEffect, useRef } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Card, CardBody, Button } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData, Fn_FillListData } from "../../store/Functions";
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { Save, ArrowLeft } from "react-feather";

function UpdateGlobalOptions() {
  const API_URL_SAVE = "UpdateGlobalOptions/0/token";
  const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/GlobalOptions/Id";

  const API_URL = `${API_WEB_URLS.MASTER}/0/token/FinancialYearMaster`;
  const [state, setState] = useState({
    id: 0,
    formData: { CompanyName: "", F_FinancialYearMaster: "", RequestOnPortal: false },
    isReady: false,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const companyNameRef = useRef(null);

  useEffect(() => {
    const initializeData = async () => {
      try {
        await Fn_FillListData(dispatch, setState, "FinancialYearMaster", API_URL + "/Id/0");
        await Fn_DisplayData(dispatch, setState, 1, API_URL_EDIT);
        setState(prevState => ({ ...prevState, isReady: true }));
      } catch (error) {
        console.error("Error initializing data:", error);
        setState(prevState => ({ ...prevState, isReady: true }));
      }
    };
    
    initializeData();
  }, [dispatch, location.state]);

  // Auto-focus on CompanyName field when component mounts
  useEffect(() => {
    if (companyNameRef.current) {
      companyNameRef.current.focus();
    }
  }, []);

  // Validation Schema
  const validationSchema = Yup.object({
    CompanyName: Yup.string()
      .required("Company name is required")
      .min(2, "Company name must be at least 2 characters")
      .max(100, "Company name must be less than 100 characters"),
    F_FinancialYearMaster: Yup.string()
      .required("Financial year is required"),
    RequestOnPortal: Yup.boolean(),
  });

  const handleSubmit = async (values) => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    let formData = new FormData();
    formData.append("CompanyName", values.CompanyName || "");
    formData.append("F_FinancialYearMaster", values.F_FinancialYearMaster || "");
    formData.append("RequestOnPortal", values.RequestOnPortal ? "1" : "0");
    formData.append("UserId", obj.uid);

   await Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "globaloptionsid",
      navigate,
      "#"
    );

    Fn_DisplayData(dispatch, setState, 1, API_URL_EDIT);

  };

  if (!state.isReady) {
    return (
      <div style={{ padding: "6px 8px", display: "flex", justifyContent: "center", alignItems: "center", minHeight: 120 }}>
        <div className="spinner-border spinner-border-sm text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div style={{ padding: "6px 8px", maxWidth: 900, margin: "0 auto" }}>
      <Card className="border shadow-none" style={{ marginBottom: 0 }}>
        <CardBody style={{ padding: "8px 12px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 6, paddingBottom: 4, borderBottom: "1px solid #dee2e6" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Global Options</span>
            <div style={{ display: "flex", gap: 6 }}>
              <Button type="button" size="sm" color="light" className="py-1 px-2" style={{ fontSize: 12 }} onClick={() => navigate(-1)}>
                <ArrowLeft size={12} className="me-1" />Back
              </Button>
              <Button type="submit" form="global-options-form" size="sm" color="primary" className="py-1 px-2" style={{ fontSize: 12 }}>
                <Save size={12} className="me-1" />Update
              </Button>
            </div>
          </div>

          <Formik
            initialValues={{
              CompanyName: (state.formData && state.formData.CompanyName) || "",
              F_FinancialYearMaster: (state.formData && state.formData.F_FinancialYearMaster) || "",
              RequestOnPortal: (state.formData && state.formData.RequestOnPortal) || false,
            }}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({ isSubmitting, errors, touched }) => (
              <Form id="global-options-form">
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px 16px", marginBottom: 8 }}>
                  <div>
                    <label htmlFor="CompanyName" style={{ fontSize: 11, fontWeight: 600, marginBottom: 2, display: "block" }}>Company Name <span className="text-danger">*</span></label>
                    <Field
                      innerRef={companyNameRef}
                      className={`form-control form-control-sm ${errors.CompanyName && touched.CompanyName ? "is-invalid" : ""}`}
                      style={{ height: 26, fontSize: 12 }}
                      type="text"
                      name="CompanyName"
                      placeholder="Company name"
                    />
                    <ErrorMessage name="CompanyName" component="div" className="text-danger" style={{ fontSize: 10 }} />
                  </div>
                  <div>
                    <label htmlFor="F_FinancialYearMaster" style={{ fontSize: 11, fontWeight: 600, marginBottom: 2, display: "block" }}>Financial Year <span className="text-danger">*</span></label>
                    <Field
                      as="select"
                      className={`form-select form-select-sm ${errors.F_FinancialYearMaster && touched.F_FinancialYearMaster ? "is-invalid" : ""}`}
                      style={{ height: 26, fontSize: 12 }}
                      name="F_FinancialYearMaster"
                    >
                      <option value="">Select</option>
                      {state.FinancialYearMaster && state.FinancialYearMaster.map((item) => (
                        <option key={item.Id} value={item.Id}>{item.Name}</option>
                      ))}
                    </Field>
                    <ErrorMessage name="F_FinancialYearMaster" component="div" className="text-danger" style={{ fontSize: 10 }} />
                  </div>
                </div>
                <div style={{ marginBottom: 8 }}>
                  <div className="form-check form-switch" style={{ fontSize: 12 }}>
                    <Field type="checkbox" className="form-check-input" name="RequestOnPortal" id="RequestOnPortal" />
                    <label className="form-check-label" htmlFor="RequestOnPortal">Request On Portal</label>
                  </div>
                  <ErrorMessage name="RequestOnPortal" component="div" className="text-danger" style={{ fontSize: 10 }} />
                </div>
              </Form>
            )}
          </Formik>
        </CardBody>
      </Card>
    </div>
  );
}

export default UpdateGlobalOptions;
